import { render, staticRenderFns } from "./purchase-orders.vue?vue&type=template&id=d9a5a27c&scoped=true&"
import script from "./purchase-orders.vue?vue&type=script&lang=js&"
export * from "./purchase-orders.vue?vue&type=script&lang=js&"
import style0 from "./purchase-orders.vue?vue&type=style&index=0&id=d9a5a27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a5a27c",
  null
  
)

export default component.exports